import { createAction, props } from '@ngrx/store';

import { ILiveCameraTab } from '@live/pages/live-camera-page/interfaces';

import ICameraUpdate = Microsoft.VideoIndexer.Live.Contracts.ICameraUpdate;
import ICamera = Microsoft.VideoIndexer.Live.Contracts.ICamera;
import ILiveCameraAgentJob = Microsoft.VideoIndexer.Live.Contracts.ILiveCameraAgentJob;
import INextPage = Microsoft.VideoIndexer.Contracts.INextPage;

export const manageCamerasClicked = createAction('[Live Cameras] manage cameras clicked');
export const viewCameraSettingsClicked = createAction(
  '[Live Cameras] view camera settings clicked',
  props<{
    cameraIds: ICamera['id'][];
  }>()
);
export const viewCameraPropertiesClicked = createAction(
  '[Live Cameras] view camera properties clicked',
  props<{
    cameraId: ICamera['id'];
  }>()
);
export const listCamerasStarted = createAction('[Live Cameras] list cameras started');
export const listCamerasSucceeded = createAction('[Live Cameras/API] list cameras success', props<{ cameras: ICamera[]; nextPage: INextPage }>());
export const listCamerasFailed = createAction('[Live Cameras/API] list cameras failure', props<{ error: string }>());
export const listCameras = createAction('[Live Cameras/API] list cameras');
export const listPinnedCameras = createAction('[Live Cameras/API] list pinned cameras', props<{ pageSize?: number; skip?: number }>());
export const listPinnedCamerasSucceeded = createAction(
  '[Live Cameras/API] list pinned cameras success',
  props<{ pinnedCameras: ICamera[]; nextPage: INextPage }>()
);
export const listPinnedCamerasFailed = createAction('[Live Cameras/API] list pinned cameras failure', props<{ error: string }>());
export const clearPinnedCameras = createAction('[Live Cameras] clear pinned cameras');
export const unpinCamera = createAction('[Live Cameras/API] unpin camera', props<{ camera: ICamera }>());
export const pinCamera = createAction('[Live Cameras/API] pin camera', props<{ camera: ICamera }>());
export const updateCamera = createAction('[Live Cameras/API] update camera', props<{ updatedCameras: ICameraUpdate[] }>());
export const updateCameraSuccess = createAction('[Live Cameras/API] update camera success', props<{ updatedCamera: ICameraUpdate }>());
export const updateCameraBatchSuccess = createAction('[Live Cameras/API] update camera batch success', props<{ updatedCameras: ICameraUpdate[] }>());
export const updateCameraFailed = createAction('[Live Cameras/API] update camera failed', props<{ camera: ICameraUpdate; error: string }>());
export const updateCameraBatchFailed = createAction('[Live Cameras/API] update camera batch failed', props<{ cameras: ICameraUpdate[] }>());
export const goToCameraPage = createAction('[Live Cameras] go to camera page', props<{ cameraId: ICamera['id'] }>());
export const goToAioPortalAction = createAction('[Live Cameras] go to AIO portal page');
export const goToCameraManagementAction = createAction('[Live Cameras] go to camera management tab');
export const manageAiInsightsClicked = createAction('[Live Cameras] Manage AI insights button clicked');
export const selectCamera = createAction('[Live Cameras] select camera', props<{ cameraId: string }>());
export const getPendingCamera = createAction('[Live Cameras/API] get pending camera', props<{ cameraId: ICamera['id'] }>());
export const getCameraSucceeded = createAction('[Live Cameras] camera success', props<{ camera: Microsoft.VideoIndexer.Live.Contracts.ICamera }>());
export const getCameraFailed = createAction('[Live Cameras] camera failure', props<{ cameraId: ICamera['id'] }>());
export const clearCameras = createAction('[Live Cameras] clear cameras');

export const setCameraTab = createAction('[Live Camera] Set Tab', props<{ tab: ILiveCameraTab }>());
export const cameraTabChanged = createAction('[Live Camera] Camera Tab Clicked', props<{ tab: ILiveCameraTab }>());

export const getCameraThumbnail = createAction('[Live Cameras/API] Get Camera Thumbnail', props<{ cameraId: ICamera['id'] }>());
export const getCameraThumbnailSuccess = createAction(
  '[Live Cameras/API] Get Camera Thumbnail Success',
  props<{ cameraId: ICamera['id']; thumbnailUrl: string }>()
);
export const getCameraThumbnailFailed = createAction(
  '[Live Cameras/API] Get Camera Thumbnail Failed',
  props<{ cameraId: ICamera['id']; error: string }>()
);
export const checkPendingCamerasStatus = createAction('[Live Cameras] Check Pending Cameras Status', props<{ cameras: ICamera[] }>());

export const listCameraAgentJobs = createAction('[Live Cameras/API] List Camera Agent Jobs', props<{ cameraId: ICamera['id'] }>());
export const listCameraAgentJobsSuccess = createAction('[Live Cameras/API] List Camera Agent Jobs Success', props<{ job: ILiveCameraAgentJob }>());
export const listCameraAgentJobsFailed = createAction('[Live Cameras/API] List Camera Agent Jobs Failed', props<{ error: string }>());
